(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcm-weekly-events-calendar"] && !Shopify.designMode) return;
  try {
    
let posts = [];

const pageOne = fetch(
  "https://worldwidecomedymonth.com/wp-json/wp/v2/tribe_events?per_page=99&page=1"
)
  .then((response) => response.json())
  .then((data) => {
    data.map((post, index) => {
      console.log(post)
      posts.push({
        event_title: post.title.rendered,
        event_link: post.link,
        event_excerpt: post.excerpt.rendered,
        event_date: post.meta._EventStartDate,
        event_url: post.meta._EventURL
      });
    });
  });

const pageTwo = fetch(
  "https://worldwidecomedymonth.com/wp-json/wp/v2/tribe_events?per_page=99&page=2"
)
  .then((response) => response.json())
  .then((data) => {
    data.map((post, index) => {
      posts.push({
        event_title: post.title.rendered,
        event_link: post.link,
        event_excerpt: post.excerpt.rendered,
        event_date: post.meta._EventStartDate,
        event_url: post.meta._EventURL
      });
    });
  });

let currentWeek = [];
function getWeekdays() {
  let firstday = dateFns.startOfWeek(new Date(), { weekStartsOn: 1 });
  currentWeek.push({ day: "monday", date: dateFns.add(firstday, { days: 0 }) });
  currentWeek.push({ day: "tuesday", date: dateFns.add(firstday, { days: 1 }) });
  currentWeek.push({ day: "wednesday", date: dateFns.add(firstday, { days: 2 }) });
  currentWeek.push({ day: "thursday", date: dateFns.add(firstday, { days: 3 }) });
  currentWeek.push({ day: "friday", date: dateFns.add(firstday, { days: 4 }) });
  currentWeek.push({ day: "saturday", date: dateFns.add(firstday, { days: 5 }) });
  currentWeek.push({ day: "sunday", date: dateFns.add(firstday, { days: 6 }) });
}

setTimeout(() => {
  getWeekdays();
  console.log("Current Week", currentWeek)
  console.log("Posts", posts)  
  for (let i = 0; i < posts.length; i++) {
    console.log("Post Date", posts[i].event_date.split(" ")[0]) 
    // Sunday
    let sunday = document.getElementById("sunday-events");
    document.getElementById("sunday-date").innerText = dateFns.format(
      currentWeek[6].date,
      "MMMM d"
    );
    if (
      posts[i].event_date.split(" ")[0] ===
      currentWeek[6].date.toISOString().split("T")[0]
    ) {
      sunday.innerHTML += `<div class="event-wrapper"><a target="_blank" href="${posts[i].event_link}" class="event-title">${posts[i].event_title}</a></div>`;
    }
    // Monday
    let monday = document.getElementById("monday-events");
    document.getElementById("monday-date").innerText = dateFns.format(
      currentWeek[0].date,
      "MMMM d"
    );
    if (
      posts[i].event_date.split(" ")[0] ===
      currentWeek[0].date.toISOString().split("T")[0]
    ) {
      monday.innerHTML += `<div class="event-wrapper"><a target="_blank" href="${posts[i].event_link}" class="event-title">${posts[i].event_title}</a></div>`;
    }
    // Tuesday
    let tuesday = document.getElementById("tuesday-events");
    document.getElementById("tuesday-date").innerText = dateFns.format(
      currentWeek[1].date,
      "MMMM d"
    );
    if (
      posts[i].event_date.split(" ")[0] ===
      currentWeek[1].date.toISOString().split("T")[0]
    ) {
      tuesday.innerHTML += `<div class="event-wrapper"><a target="_blank" href="${posts[i].event_link}" class="event-title">${posts[i].event_title}</a></div>`;
    }

    // Wednesday
    let wednesday = document.getElementById("wednesday-events");
    document.getElementById("wednesday-date").innerText = dateFns.format(
      currentWeek[2].date,
      "MMMM d"
    );
    if (
      posts[i].event_date.split(" ")[0] ===
      currentWeek[2].date.toISOString().split("T")[0]
    ) {
      wednesday.innerHTML += `<div class="event-wrapper"><a target="_blank" href="${posts[i].event_link}" class="event-title">${posts[i].event_title}</a></div>`;
    }

    // Thursday
    let thursday = document.getElementById("thursday-events");
    document.getElementById("thursday-date").innerText = dateFns.format(
      currentWeek[3].date,
      "MMMM d"
    );
    if (
      posts[i].event_date.split(" ")[0] ===
      currentWeek[3].date.toISOString().split("T")[0]
    ) {
      thursday.innerHTML += `<div class="event-wrapper"><a target="_blank" href="${posts[i].event_link}" class="event-title">${posts[i].event_title}</a></div>`;
    }

    // Friday
    let friday = document.getElementById("friday-events");
    document.getElementById("friday-date").innerText = dateFns.format(
      currentWeek[4].date,
      "MMMM d"
    );
    if (
      posts[i].event_date.split(" ")[0] ===
      currentWeek[4].date.toISOString().split("T")[0]
    ) {
      friday.innerHTML += `<div class="event-wrapper"><a target="_blank" href="${posts[i].event_link}" class="event-title">${posts[i].event_title}</a></div>`;
    }

    // Saturday
    let saturday = document.getElementById("saturday-events");
    document.getElementById("saturday-date").innerText = dateFns.format(
      currentWeek[5].date,
      "MMMM d"
    );
    if (
      posts[i].event_date.split(" ")[0] ===
      currentWeek[5].date.toISOString().split("T")[0]
    ) {
      saturday.innerHTML += `<div class="event-wrapper"><a target="_blank" href="${posts[i].event_link}" class="event-title">${posts[i].event_title}</a></div>`;
    }
  }
}, 2000);


  } catch(e) { console.error(e); }
})();
})();
